import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const AnalysisOrbIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      {/* Organic blob body — centered and sized up */}
      <path
        d="M16 7C18.8 6.7 21.3 8 22.8 10.4C24.3 12.7 24.3 16 22.8 18.3C21.3 20.7 18.8 22.2 16 22.4C13.2 22.6 10.8 21.1 9.3 18.8C7.8 16.5 7.5 13.3 9 11C10.4 8.5 13.2 7.3 16 7Z"
        fill="currentColor"
        fillOpacity="0.1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      {/* Antenna */}
      <line
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.3"
        x1="16"
        x2="17"
        y1="7.5"
        y2="4.5"
      />
      <circle cx="17" cy="3.8" fill="currentColor" r="1" />
      {/* Eyes — looking up and to the side (thinking) */}
      <circle cx="13.5" cy="13.5" fill="currentColor" r="1" />
      <circle cx="18" cy="13" fill="currentColor" r="1" />
      {/* Mouth — dotted, slightly pursed for thinking expression */}
      <circle cx="14.5" cy="17.5" fill="currentColor" r="0.5" />
      <circle cx="15.5" cy="17.8" fill="currentColor" r="0.5" />
      <circle cx="16.5" cy="17.8" fill="currentColor" r="0.5" />
      <circle cx="17.5" cy="17.5" fill="currentColor" r="0.5" />
      {/* Thought bubbles — trailing off to the upper right */}
      <circle cx="22" cy="6" fill="currentColor" fillOpacity="0.5" r="1.2" />
      <circle cx="24.5" cy="4" fill="currentColor" fillOpacity="0.35" r="0.8" />
      <circle
        cx="26.2"
        cy="2.5"
        fill="currentColor"
        fillOpacity="0.2"
        r="0.5"
      />
    </BaseIcon>
  );
};
